import { useInjection } from "@linkfluence/core/di";
import { useQuery } from "@tanstack/react-query";
import { Project } from "@radarly/models/project";
import {
  InsightPageRepo,
  InsightPageRepositoryUID,
  Pagination,
} from "../repositories/InsightPageRepo";

export function useGetLeanInsightPages(
  project: Project,
  workspaceId: number,
  pagination?: Pagination
) {
  const repository = useInjection<InsightPageRepo>(InsightPageRepositoryUID);
  const { data, isLoading } = useQuery(
    ["/get-all-workspaces-insight-pages", workspaceId, project.id],
    () => {
      return repository.getLeanInsightPages(
        project.id,
        workspaceId,
        pagination || { start: 0, limit: 1000 } // 1000 to be sure to fetch all pages
      );
    }
  );
  return {
    pages: data || [],
    loading: !!isLoading,
  };
}
